/**
 * @generated SignedSource<<13c58fef270502f858af557e11e38680>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type removeApprover_softwareReleasesApprovers_jiraVersion$data = {
  readonly __id: string;
  readonly " $fragmentType": "removeApprover_softwareReleasesApprovers_jiraVersion";
};
export type removeApprover_softwareReleasesApprovers_jiraVersion$key = {
  readonly " $data"?: removeApprover_softwareReleasesApprovers_jiraVersion$data;
  readonly " $fragmentSpreads": FragmentRefs<"removeApprover_softwareReleasesApprovers_jiraVersion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "removeApprover_softwareReleasesApprovers_jiraVersion",
  "selections": [
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "15af9d43789b08db6dabb0770ed8710d";

export default node;
